import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Gallery from '../components/Gallery';
import { teamData, gallery, socialMedia } from '../data/mock';

const GalleryPage = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header logo={teamData.logo} />
      
      {/* Hero Section */}
      <section className="pt-32 pb-10 bg-gradient-to-b from-black to-gray-900">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <h1 className="text-5xl md:text-7xl font-black text-white mb-4">
              <span className="text-cyan-400">Shooting</span>
            </h1>
            <div className="w-24 h-1 bg-gradient-to-r from-cyan-500 to-yellow-400 mx-auto mb-6"></div>
            <p className="text-xl md:text-2xl text-gray-400">
              2026 Season Line-Up
            </p>
          </div>
        </div>
      </section>

      <Gallery images={gallery} />
      
      <Footer socialMedia={socialMedia} teamName={teamData.name} logo={teamData.logo} />
    </div>
  );
};

export default GalleryPage;
